
const API_URL = process.env.REACT_APP_API_URL;

const uploadFile = async (file) => {
  
  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(`${API_URL}/upload`, {
    method: 'POST',
    body: formData,
  });

 
  const responseData = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(responseData.error || responseData.message || 'File upload failed');
  }

  return responseData;
};

export { uploadFile };
